import { environment } from 'src/environments/environment';

export const TOKEN = 'APP_TOKEN_' + environment.ENVIRONMENT;
export const TOKEN_REFRESH = 'APP_TOKEN_REFRESH_' + environment.ENVIRONMENT;
export const USER = 'APP_USER_' + environment.ENVIRONMENT;
export const SPLASH = 'APP_SPLASH_' + environment.ENVIRONMENT;
export const FIRST_USE = 'APP_FIRST_USE_' + environment.ENVIRONMENT;
export const THEME = 'APP_THEME_' + environment.ENVIRONMENT;
export const SYSTEM_INFO = 'SYSTEM_INFO_' + environment.ENVIRONMENT;
export const SYSTEM_MENU = 'SYSTEM_MENU_' + environment.ENVIRONMENT;
export const IS_MODE_MENU = 'IS_MODE_MENU_' + environment.ENVIRONMENT;
export const GOOGLE_AUTH_TOKEN = 'GOOGLE_AUTH_TOKEN_' + environment.ENVIRONMENT;
export const GOOGLE_AUTH_CALENDAR_TOKEN =
  'GOOGLE_AUTH_CALENDAR_TOKEN_' + environment.ENVIRONMENT;
export const PWA_INSTALL_BANNER_DISMISSED =
  'PWA_INSTALL_BANNER_DISMISSED_' + environment.ENVIRONMENT;
export const LAST_PAGE = 'LAST_PAGE_' + environment.ENVIRONMENT;
export const GUEST = 'GUEST_' + environment.ENVIRONMENT;
export const PLATFORM = 'PLATFORM_' + environment.ENVIRONMENT;
export const PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS_' + environment.ENVIRONMENT;
export const PUSH_NOTIFICATIONS_ACTIVE =
  'PUSH_NOTIFICATIONS_ACTIVE_' + environment.ENVIRONMENT;
export const KPI_STATES = 'KPI_STATES_' + environment.ENVIRONMENT;

export const PREFER_MODERN_LANGUAGE =
  'PREFER_MODERN_LANGUAGE_' + environment.ENVIRONMENT;

export const SHARE_LAST_TEMPLATE =
  'SHARE_LAST_TEMPLATE_' + environment.ENVIRONMENT;

export const LEGAL_ACCEPTED_VERSIONS =
  'LEGAL_ACCEPTED_VERSIONS_' + environment.ENVIRONMENT;

export const SEEN_NO_ADDRESS_MODAL =
  'SEEN_NO_ADDRESS_MODAL_' + environment.ENVIRONMENT;


export const SEEN_ONBOARDING =
  'SEEN_ONBOARDING_' + environment.ENVIRONMENT;

export const BASE = environment.URL_BASE;
export const API = environment.URL_BASE + '/api/v1/';
export const TOAST_ICON = 'chevron-up';
export const LOADING_ICON = 'circular';
